<template>
    <div class="main-content-container container-fluid  ">
        <div class="page-header row no-gutters py-4  mb-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{$t('RISK_ANALYSIS.TITLE')}}</span>
                <br/>
            </div>
        </div>

        <w-card size="100">
            <div class="row mb-4">

                <div class="col-12 col-lg-6 text-lg-left text-center ">
                    <site-picker class="mr-1 mb-1 mb-xl-0" :on-site-selected="onSiteSelected"/>
                    <silo-picker class="mr-1 mb-1 mb-xl-0" :site="site" :on-silo-selected="onSiloSelected"/>
                </div>

            </div>
            <hr>
            <div>
                <div class="text-right w-100 pr-3">
                    <el-tooltip placement="left-end">
                        <div slot="content">
                            <table>
                                <col width="50">
                                <tr>
                                    <th>0-25</th>
                                    <th>{{$t('RISK_ANALYSIS.LOW')}}</th>
                                </tr>
                                <tr>
                                    <th>25-50</th>
                                    <th>{{$t('RISK_ANALYSIS.MEDIUM')}}</th>
                                </tr>
                                <tr>
                                    <th>50-75</th>
                                    <th>{{$t('RISK_ANALYSIS.HIGH')}}</th>
                                </tr>
                                <tr>
                                    <th>75-100</th>
                                    <th>{{$t('RISK_ANALYSIS.VERY_HIGH')}}</th>
                                </tr>
                            </table>
                        </div>
                        <i class="fas fa-info"></i>
                    </el-tooltip>
                </div>
                <risk-analysis-chart :site="site" :silo="silo" :sections="sections"/>
            </div>

        </w-card>
    </div>
</template>

<script>
    import wCard from "../components/common/wCard";
    import sitePicker from "../components/common/sitePicker";
    import siloPicker from "../components/common/siloPicker";
    import riskAnalysisChart from "../components/common/charts/riskAnalysisChart";
    import api from "../utils/api/api";

    export default {
        name: "riskAnalysis",
        components: {
            "w-card": wCard,
            "site-picker": sitePicker,
            "silo-picker": siloPicker,
            "risk-analysis-chart": riskAnalysisChart
        },
        data() {
            return {
                site: undefined,
                silo: undefined,
                sections: undefined
            }
        },
        methods: {
            onSiteSelected(site) {
                this.site = site;
            },
            onSiloSelected(silo) {
                this.silo = silo;
                api.getSilo(this.site.id, this.silo.id).then(value => {
                    this.sections = value.silo.sections;
                });
            }

        }
    }
</script>

<style scoped>

</style>